import React from "react";
import Apply from "../../../assets/image/apply-2.jpg";
import { Link } from "react-router-dom";

const Immigration = () => {


    return (
        <section
            className="relative "
        >
            <div className="max-w-7xl mx-auto px-4 pt-8 md:pt-16">

                {/* TOP IMAGE + RED PANEL */}
                <div className="flex flex-col lg:flex-row overflow-hidden shadow-lg">

                    {/* IMAGE */}
                    <div className="h-64 md:h-[320px] w-full lg:w-[350px] flex-shrink-0">
                        <img
                            src={Apply}
                            alt="notimg"
                            className="w-full h-full object-cover  md:rounded-tr-none"
                        />
                    </div>

                    {/* RED PANEL */}
                    <div className="bg-[#ec4e4f] text-white p-6 md:p-10 flex flex-col justify-center over-flow-hidden md:rounded-bl-none relative">
                        <h4 className="text-[20px] mb-3 opacity-1 text-center md:text-left">
                            Get a Free Online Immigration Assessment Today!

                        </h4>
                        <h2 className="text-2xl md:text-[36px] font-bold mb-6 leading-tight text-center md:text-left">
                            Trusted by clients and partner firms for exceptional service quality and consistently high satisfaction.


                        </h2>
                        <div className="flex justify-center md:justify-start">
                            <Link to="/contact-us" className="border-2 relative z-[999] border-white px-6 py-3 font-[600] hover:bg-white text-[18px] hover:text-[#ec4e4f] transition">
                                Apply Immigration Now
                                →
                            </Link>
                        </div>
                        <div className="absolute left-[-70px] bottom-[-75px] 
                w-[255px] h-[255px] 
                rounded-full 
                bg-white/10">
                        </div>
                        <div className="absolute top-[-70px] right-[-190px] 
                w-[255px] h-[255px] 
                rounded-full 
                bg-white/10">
                        </div>
                    </div>
                </div>

                {/* COUNTERS */}

            </div>
        </section>
    );
};


export default Immigration;
